/* eslint-disable */
export default {
  419: 'Latijns-Amerika',
  AR: 'Argentinië',
  AT: 'Oostenrijk',
  AU: 'Australië',
  BE: 'België',
  BG: 'Bulgarije',
  BH: 'Bahrein',
  BJ: 'Benin',
  BR: 'Brazilië',
  CA: 'Canada',
  CH: 'Zwitserland',
  CL: 'Chili',
  CN: 'China',
  CO: 'Colombia',
  CY: 'Cyprus',
  CZ: 'Tsjechische Republiek',
  DE: 'Duitsland',
  DK: 'Denemarken',
  DO: 'Dominicaanse Republiek',
  EE: 'Estland',
  ES: 'Spanje',
  FI: 'Finland',
  FR: 'Frankrijk',
  GB: 'Verenigd Koninkrijk',
  GE: 'Georgië',
  GH: 'Ghana',
  GN: 'Guinea',
  GR: 'Griekenland',
  HK: 'Hongkong',
  HR: 'Kroatië',
  HU: 'Hongarije',
  ID: 'Indonesië',
  IE: 'Ierland',
  IL: 'Israël',
  IN: 'India',
  IT: 'Italië',
  JP: 'Japan',
  KE: 'Kenia',
  KR: 'Zuid-Korea',
  LT: 'Litouwen',
  LU: 'Luxemburg',
  LV: 'Letland',
  MX: 'Mexico',
  MY: 'Maleisië',
  NG: 'Nigeria',
  NL: 'Nederland',
  NO: 'Noorwegen',
  NZ: 'Nieuw-Zeeland',
  PA: 'Panama',
  PE: 'Peru',
  PH: 'Flippijnen',
  PK: 'Pakistan',
  PL: 'Polen',
  PR: 'Puerto Rico',
  PT: 'Portugal',
  RO: 'Roemenië',
  SE: 'Zweden',
  SG: 'Singapore',
  SI: 'Slovenië',
  SK: 'Slowakije',
  SV: 'El Salvador',
  TR: 'Turkije',
  TW: 'Taiwan',
  UA: 'Oekraïne',
  US: 'Verenigde Staten',
  VN: 'Vietnam',
  ZA: 'Zuid-Afrika',
} as const;

// @key: @#@"419"@#@ @source: @#@"Latin America"@#@
// @key: @#@"AR"@#@ @source: @#@"Argentina"@#@
// @key: @#@"AT"@#@ @source: @#@"Austria"@#@
// @key: @#@"AU"@#@ @source: @#@"Australia"@#@
// @key: @#@"BE"@#@ @source: @#@"Belgium"@#@
// @key: @#@"BG"@#@ @source: @#@"Bulgaria"@#@
// @key: @#@"BH"@#@ @source: @#@"Bahrain"@#@
// @key: @#@"BJ"@#@ @source: @#@"Benin"@#@
// @key: @#@"BR"@#@ @source: @#@"Brazil"@#@
// @key: @#@"CA"@#@ @source: @#@"Canada"@#@
// @key: @#@"CH"@#@ @source: @#@"Switzerland"@#@
// @key: @#@"CL"@#@ @source: @#@"Chile"@#@
// @key: @#@"CN"@#@ @source: @#@"China"@#@
// @key: @#@"CO"@#@ @source: @#@"Colombia"@#@
// @key: @#@"CY"@#@ @source: @#@"Cyprus"@#@
// @key: @#@"CZ"@#@ @source: @#@"Czech Republic"@#@
// @key: @#@"DE"@#@ @source: @#@"Germany"@#@
// @key: @#@"DK"@#@ @source: @#@"Denmark"@#@
// @key: @#@"DO"@#@ @source: @#@"Dominican Republic"@#@
// @key: @#@"EE"@#@ @source: @#@"Estonia"@#@
// @key: @#@"ES"@#@ @source: @#@"Spain"@#@
// @key: @#@"FI"@#@ @source: @#@"Finland"@#@
// @key: @#@"FR"@#@ @source: @#@"France"@#@
// @key: @#@"GB"@#@ @source: @#@"United Kingdom"@#@
// @key: @#@"GE"@#@ @source: @#@"Georgia"@#@
// @key: @#@"GH"@#@ @source: @#@"Ghana"@#@
// @key: @#@"GN"@#@ @source: @#@"Guinea"@#@
// @key: @#@"GR"@#@ @source: @#@"Greece"@#@
// @key: @#@"HK"@#@ @source: @#@"Hong Kong"@#@
// @key: @#@"HR"@#@ @source: @#@"Croatia"@#@
// @key: @#@"HU"@#@ @source: @#@"Hungary"@#@
// @key: @#@"ID"@#@ @source: @#@"Indonesia"@#@
// @key: @#@"IE"@#@ @source: @#@"Ireland"@#@
// @key: @#@"IL"@#@ @source: @#@"Israel"@#@
// @key: @#@"IN"@#@ @source: @#@"India"@#@
// @key: @#@"IT"@#@ @source: @#@"Italy"@#@
// @key: @#@"JP"@#@ @source: @#@"Japan"@#@
// @key: @#@"KE"@#@ @source: @#@"Kenya"@#@
// @key: @#@"KR"@#@ @source: @#@"South Korea"@#@
// @key: @#@"LT"@#@ @source: @#@"Lithuania"@#@
// @key: @#@"LU"@#@ @source: @#@"Luxembourg"@#@
// @key: @#@"LV"@#@ @source: @#@"Latvia"@#@
// @key: @#@"MX"@#@ @source: @#@"Mexico"@#@
// @key: @#@"MY"@#@ @source: @#@"Malaysia"@#@
// @key: @#@"NG"@#@ @source: @#@"Nigeria"@#@
// @key: @#@"NL"@#@ @source: @#@"Netherlands"@#@
// @key: @#@"NO"@#@ @source: @#@"Norway"@#@
// @key: @#@"NZ"@#@ @source: @#@"New Zealand"@#@
// @key: @#@"PA"@#@ @source: @#@"Panama"@#@
// @key: @#@"PE"@#@ @source: @#@"Peru"@#@
// @key: @#@"PH"@#@ @source: @#@"Philippines"@#@
// @key: @#@"PK"@#@ @source: @#@"Pakistan"@#@
// @key: @#@"PL"@#@ @source: @#@"Poland"@#@
// @key: @#@"PR"@#@ @source: @#@"Puerto Rico"@#@
// @key: @#@"PT"@#@ @source: @#@"Portugal"@#@
// @key: @#@"RO"@#@ @source: @#@"Romania"@#@
// @key: @#@"SE"@#@ @source: @#@"Sweden"@#@
// @key: @#@"SG"@#@ @source: @#@"Singapore"@#@
// @key: @#@"SI"@#@ @source: @#@"Slovenia"@#@
// @key: @#@"SK"@#@ @source: @#@"Slovakia"@#@
// @key: @#@"SV"@#@ @source: @#@"El Salvador"@#@
// @key: @#@"TR"@#@ @source: @#@"Türkiye"@#@
// @key: @#@"TW"@#@ @source: @#@"Taiwan"@#@
// @key: @#@"UA"@#@ @source: @#@"Ukraine"@#@
// @key: @#@"US"@#@ @source: @#@"United States"@#@
// @key: @#@"VN"@#@ @source: @#@"Vietnam"@#@
// @key: @#@"ZA"@#@ @source: @#@"South Africa"@#@
